import { Component, OnInit, Inject, EventEmitter } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { MatLegacyDialogRef as MatDialogRef, MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA } from '@angular/material/legacy-dialog';
import { log } from 'console';
import { OspService } from 'src/app/core/master-services/osp.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { warningMessage } from 'src/app/constants';
import * as moment from 'moment';
import { getUnique, getUniqueByKey, yearWeekToDate } from 'src/app/constants';
import { DefaultService } from 'src/app/services/default.service';


@Component({
  selector: 'app-shifts-edit-dialog',
  templateUrl: './shifts-edit-dialog.component.html',
  styleUrls: ['./shifts-edit-dialog.component.scss']
})
export class ShiftsEditDialogComponent implements OnInit {
  addShiftsEventEmitter = new EventEmitter();
  editShiftsEventEmitter = new EventEmitter();
  rowData = [];
  errorMessage1: any;
  errorMessageUpdate = false;
  master_id: any;
  master_name: any;
  key_item: any;
  data_item: any;
  business_entity: any;
  new_key_item: any;
  cstatus: any;
  showaddpopup: boolean = false;
  showeditpopup: boolean = false;
  dock: any;
  popupname: any;
  shiftNumber: any;
  dayWeek: any;
  startTime: any;
  endTime: any;
  inMasterCalendar: any;
  inNextDay: any;
  dataItem: any;
  effectiveFrom: any;
  effectiveTo: any;
  enableError: boolean = false;
  userForm: UntypedFormGroup;
  shiftNumbers: any[] = [];
  dayWeeks: any[] = [];
  masterCalendar: any[] = [];
  nextDay: any[] = [];
  errorMessage: any;
  hoursArray = new Array(24);
  mintuesArray = new Array(60);
  addOrEditform: UntypedFormGroup = this.formBuilder.group({
    dock: ['', Validators.required],
    shiftNumber: [1],
    dayWeek: [2],
    inMasterCalendar: ['N'],
    inNextDay: ['N'],
    effectiveTo: [null],
    effectiveFrom: [null, Validators.required],
    startHoursHH: ['', Validators.required],
    startMintuesMM: ['', Validators.required],
    endHoursHH: ['', Validators.required],
    endMintuesMM: ['', Validators.required],
  },
  );
  warningMessage: string;
  itContact: any;
  successMessage: string;
  onInitprodDate: any;
  onIntprodDateTo: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data,
    private readonly dialogeRef: MatDialogRef<ShiftsEditDialogComponent>,
    private readonly formBuilder: UntypedFormBuilder,
    private readonly ospService: OspService,
    private readonly spinner: NgxSpinnerService,
    public readonly defaultService: DefaultService

  ) { }
  get addOrEdit() {
    return this.addOrEditform.controls;
  }
  ngOnInit(): void {

    this.business_entity = localStorage.getItem('namcvalue');
    this.shiftNumbers = [
      { value: 1 },
      { value: 2 },
      { value: 3 }
    ];
    this.dayWeeks = [
      { label: 'Sunday', value: 1 },
      { label: 'Monday', value: 2 },
      { label: 'Tuesday', value: 3 },
      { label: 'Wednesday', value: 4 },
      { label: 'Thursday', value: 5 },
      { label: 'Friday', value: 6 },
      { label: 'Saturday', value: 7 },
    ];

    this.masterCalendar = [
      { value: 'N' },
      { value: 'Y' },
    ];
    this.nextDay = [
      { value: 'N' },
      { value: 'Y' },
    ];


    if (this.data?.mode === 'edit') {
      if (this.data.data?.dock) {
        this.addOrEdit.dock.setValue(
          this.data.data.dock
        );

      }

    } else if (this.data?.mode === 'add') {
      setTimeout(() => {
        if (this.assignDefaultDock()) {
          this.onDockChange();
        }
      }, 500);
    }

    this.addOrEditform.controls.startHoursHH.valueChanges.subscribe((hour: number) => {
      if (hour !== null) {
        this.addOrEditform.controls.startMintuesMM.setValue(0);  // Set minutes to 00
      }
    });

    this.addOrEditform.controls.endHoursHH.valueChanges.subscribe((hour: number) => {
      if (hour !== null) {
        this.addOrEditform.controls.endMintuesMM.setValue(0);  // Set minutes to 00
      }
    });
  }

  onDockChange() {
    //console.log(this.addOrEditform.controls.dock);
    this.defaultService.setDockCode(JSON.stringify([{ dock: this.addOrEditform.controls.dock?.value }]));
  }

  assignDefaultDock() {
    try {
      if (this.data.dockList?.length > 0) {
        const defaultdockArray: any[] = JSON.parse(this.defaultService.getCurrentDockCode());
        if (Array.isArray(defaultdockArray)) {
          const validDocks = new Set(defaultdockArray.map(item => item.dock));
          this.addOrEditform.patchValue(this.data.dockList.find(item => validDocks.has(item.dock)));
          if (this.addOrEditform.controls.dock?.value) {
            return true;
          }
        }
      }
      return false;
    } catch (error) {
      console.log('Error in assigning default dock', error);
      return false;
    }
  }

  formatNumber(num: number): string {
    return num < 10 ? '0' + num : num.toString();
  }
  submitted: boolean = false;
  convertDateFormat(date: string): string {
    const dateObj = new Date(date);
    const month = dateObj.getMonth() + 1;  // Months are 0-indexed
    const day = dateObj.getDate();
    const year = dateObj.getFullYear();

    // Return the date in mm/dd/yyyy format
    return `${month < 10 ? '0' + month : month}/${day < 10 ? '0' + day : day}/${year}`;
  }
  onEffectiveFromChange(event: Event) {
    const input = event.target as HTMLInputElement;
    this.effectiveFrom = input.value;

    // If the "Effective From" date is greater than the "Effective To" date, update "Effective To"
    if (this.effectiveFrom && this.effectiveTo && this.effectiveFrom > this.effectiveTo) {
      this.effectiveTo = this.effectiveFrom;
    }
  }

  // private isStartTimeGreaterThanEndTime(startTime: string, endTime: string): boolean {
  //   const [startHours, startMinutes] = startTime.split(':').map(Number);
  //   const [endHours, endMinutes] = endTime.split(':').map(Number);

  //   const now = new Date();
  //   const startDate = new Date(now);
  //   const endDate = new Date(now);

  //   startDate.setHours(startHours, startMinutes, 0, 0);
  //   endDate.setHours(endHours, endMinutes, 0, 0);

  //   const maxShiftHours = 12;

  //   // Handling overnight scenario: If end time is earlier than start time, adjust for overnight.
  //   if (endDate <= startDate) {
  //     // Allow only if start time is in the evening (after 6 PM)
  //     if (startHours >= 18) {
  //       endDate.setDate(endDate.getDate() + 1); // Adjust end time to the next day

  //       const diffInMs = endDate.getTime() - startDate.getTime();
  //       const diffInHours = diffInMs / (1000 * 60 * 60);

  //       // If the shift duration is too long (more than maxShiftHours), consider it invalid.
  //       if (diffInHours > maxShiftHours) {
  //         return true; // Invalid
  //       }

  //       return false; // Valid overnight shift
  //     }

  //     // Not an evening start time — invalid overnight shift
  //     return true;
  //   }

  //   // Same-day range: valid only if start < end and not the same.
  //   return startDate >= endDate;
  // } 


  // check for 18-3
  private isStartTimeGreaterThanEndTime(startTime: string, endTime: string): boolean {
    const [startHours, startMinutes] = startTime.split(':').map(Number);
    const [endHours, endMinutes] = endTime.split(':').map(Number);

    const startInMinutes = startHours * 60 + startMinutes;
    const endInMinutes = endHours * 60 + endMinutes;

    return startInMinutes > endInMinutes;
  }

  private formatDateToDDMMYYYY(dateStr: string): string {
    // Ensure the date string is not null or empty
    if (!dateStr || typeof dateStr !== 'string') {
      console.warn('Invalid date format provided:', dateStr);
      return '';
    }

    // Split the date into parts (month, day, year)
    const [month, day, year] = dateStr.split('/');

    // Return the formatted date as DDMMYYYY
    return `${day.padStart(2, '0')}${month.padStart(2, '0')}${year}`;
  }



  private parseDate(dateStr: string | null): Date | null {
    if (!dateStr || typeof dateStr !== 'string') {
      console.warn('parseDate: Invalid or null date string:', dateStr);
      return null;
    }

    const parts = dateStr.split('/');
    if (parts.length !== 3) {
      console.error('Invalid date format, expected MM/DD/YYYY:', dateStr);
      return null;
    }

    const [month, day, year] = parts.map(Number);

    if (isNaN(month) || isNaN(day) || isNaN(year)) {
      console.error('Date parsing failed. Non-numeric values found:', parts);
      return null;
    }

    return new Date(year, month - 1, day); // JS months are 0-based
  }








  // Function to check for conflicting shifts based on time range overlap
  private isTimeRangeOverlap(startTime1: string, endTime1: string, startTime2: string, endTime2: string): boolean {
    const toMinutes = (timeStr: string): number => {
      if (!timeStr || !timeStr.includes(':')) {
        console.error('Invalid time string:', timeStr);
        return 0;
      }
      const [hh, mm] = timeStr.split(':').map(Number);
      return hh * 60 + mm;
    };

    if (!startTime1 || !endTime1 || !startTime2 || !endTime2) {
      console.error('One or more time values are undefined:', {
        startTime1,
        endTime1,
        startTime2,
        endTime2
      });
      return false;
    }

    let start1 = toMinutes(startTime1);
    let end1 = toMinutes(endTime1);
    let start2 = toMinutes(startTime2);
    let end2 = toMinutes(endTime2);

    if (end1 <= start1) end1 += 1440; // overnight shift (next day)
    if (end2 <= start2) end2 += 1440; // overnight shift (next day)

    return (start1 < end2) && (start2 < end1); // adjusted to be strictly overlapping
  }


  // Function to check for shift conflicts based on new shift and existing shifts
  private checkShiftConflict(newShiftData: any, existingShifts: any[]): boolean {
    const { startTimeNew, endTimeNew, effectiveFrom, effectiveTo } = newShiftData;

    // Sort the shifts by `from_date` in descending order to prioritize the latest shift
    existingShifts.sort((a, b) => {
      const dateA = this.parseDate(a.from_date);
      const dateB = this.parseDate(b.from_date);
      return dateB.getTime() - dateA.getTime(); // Descending order
    });

    // Check the latest shift for conflict
    const conflictingShift = existingShifts[0];


    const existingFromDate = this.parseDate(conflictingShift?.from_date);
    const existingToDate = conflictingShift?.to_date ? this.parseDate(conflictingShift?.to_date) : null;
    const existingEffectiveTo = existingToDate || new Date('12/31/2999'); // If `to_date` is null, use '12/31/2999'

    // Check if the new shift's `effectiveFrom` date is within the range of the existing shift's `from_date` and `to_date`
    // const isDateConflict = effectiveFrom && existingFromDate && effectiveFrom >= existingFromDate && effectiveFrom <= existingEffectiveTo;
    const isDateConflict = effectiveFrom && existingFromDate && effectiveFrom >= existingEffectiveTo && effectiveFrom >= existingEffectiveTo;

    // Check if the time ranges overlap
    const isTimeOverlap = this.isTimeRangeOverlap(startTimeNew, endTimeNew, conflictingShift?.start_time, conflictingShift?.end_time);

    // If both time and date overlap, we have a conflict
    if (isTimeOverlap && isDateConflict) {
      const formattedDate = this.formatDateToDDMMYYYY(conflictingShift.from_date);
      // Show conflict warning message with the correct shift details
      this.warningMessage = `This configuration conflicts with shift [${conflictingShift.shift_no}, ${conflictingShift.day_of_week}, ${formattedDate} ...]`;
      return false; // Return false to indicate a conflict
    }

    return true; // No conflict, return true
  }







  // Handle API response and check for conflicting shifts
  private handleApiResponse(res: any, addEmittedData: any) {
    const conflictingShifts = this.checkForConflictingShifts(res.body.shiftResponce.data, addEmittedData);

    if (conflictingShifts.length > 0) {
      // Get the shift with the latest from_date
      const latestConflict = conflictingShifts.sort((a, b) => {
        const dateA = this.parseDate(a.from_date);
        const dateB = this.parseDate(b.from_date);
        return dateB.getTime() - dateA.getTime(); // Descending
      })[0];

      const latestShiftNo = latestConflict.shift_no;
      const latestDay = latestConflict.day_of_week || latestConflict.day;
      const latestFromDate = latestConflict.from_date?.replaceAll('/', '') || 'UnknownDate';

      this.warningMessage = `This configuration conflicts with shift [${latestShiftNo}, ${latestDay}, ${latestFromDate} ...] and cannot use '12/31/2999' as Effective To date.`;
    }


    // No conflicts, proceed with emitting the shift data
    this.spinner.hide();
    this.addShiftsEventEmitter.emit(addEmittedData);
    this.dialogeRef.close();
  }

  // Check for conflicting shifts based on time range overlap
  private checkForConflictingShifts(existingShifts: any[], addEmittedData: any): any[] {
    const conflicts = [];

    for (const shift of existingShifts) {
      const existingStart = shift.start_time;
      const existingEnd = shift.end_time;

      const conflictFound = this.isTimeRangeOverlap(
        addEmittedData.startTimeNew, addEmittedData.endTimeNew,
        shift.start_time, shift.end_time
      );

      if (conflictFound) {
        conflicts.push(shift);
      }
    }

    return conflicts;
  }





  formatDate(dateStr: string | Date): string {
    const date = new Date(dateStr);
    const year = date.getFullYear();
    const month = `${date.getMonth() + 1}`.padStart(2, '0');
    const day = `${date.getDate()}`.padStart(2, '0');
    return `${year}-${month}-${day}`;
  }


  isEffectiveDateInRange = (effectiveFrom: string, effectiveTo:
    string, existingFrom: string, existingTo: string) => {
    const defaultMaxDate = '2999-12-31';

    const newFrom = this.formatDate(effectiveFrom);
    const newTo = this.formatDate(effectiveTo || defaultMaxDate);
    const partFrom = this.formatDate(existingFrom);
    const partTo = this.formatDate(existingTo || defaultMaxDate);

    return newFrom <= partTo && newTo >= partFrom;
  };

  // Convert time string (HH:mm) to total minutes (from midnight)
  convertToFullTimeFormat(time: string): number {
    const [hours, minutes] = time.split(':').map(Number);
    return hours * 60 + minutes; // Return total minutes from midnight
  }

  // Calculate the duration in minutes between startTime and endTime
  calculateDuration(startTime: number, endTime: number): number {
    let durationInMinutes = endTime - startTime;

    // If the end time is earlier than start time (meaning it crosses over midnight), adjust for next day
    if (durationInMinutes < 0) {
      durationInMinutes += 1440; // Add 1440 minutes (1 full day) if endTime is on the next day
    }

    return durationInMinutes;
  }
  formatDurationAsInterval(durationInMinutes: number): string {
    const hours = Math.floor(durationInMinutes / 60);
    const minutes = durationInMinutes % 60;

    // Return formatted interval string
    return `${hours} hours ${minutes} minutes`;
  }


  editRowShiftsDetails() {
    if (this.addOrEditform.invalid) {
      this.submitted = true;
      return;
    }

    const editEmittedData = {
      master_id: this.addOrEdit.masterId.value.master_id,
      master_name: this.addOrEdit.masterName.value.name,
      startTime: this.addOrEdit.startTime.value,
      data_item: this.addOrEdit.dataItem.value,
    };
    this.editShiftsEventEmitter.emit(editEmittedData);
    this.dialogeRef.close();

  }
  onTimeChange(newTime: string): void {
    this.startTime = newTime;  // Update the component model with the new time
  }
  removeMessage() {
    this.warningMessage = '';
    this.successMessage = '';
  };

  errorCallback = (error) => {
    console.error(error);
    this.hideSpinner();

    this.removeMessage();
    this.warningMessage = `${warningMessage.apiLogicFail}  ${this.itContact}.`;
  };
  hideSpinner() {
    this.spinner.hide();
  }



  callRespectiveFunction() {
    if (this.data?.mode === 'edit') {
      this.editRowShiftsDetails();
    } else {

      this.addShiftsDetails();
    }
  }
  onKeyPress(event: KeyboardEvent) {
    const allowedKeys = ['Backspace', 'Tab', 'ArrowLeft', 'ArrowRight', 'Delete'];
    const isNumber = /^[0-9]$/.test(event.key);

    // Allow number keys, allowed keys, and prevent default for others
    if (!isNumber && !allowedKeys.includes(event.key)) {
      event.preventDefault();
    }
  }


  //latest
  addShiftsDetails() {
    this.errorMessage = '';
    if (!this.addOrEditform.valid) {
      this.submitted = true;
      return;
    }

    const { startHoursHH, startMintuesMM, endHoursHH, endMintuesMM } = this.addOrEditform.value;
    const startTimeNew = `${startHoursHH.toString().padStart(2, '0')}:${startMintuesMM.toString().padStart(2, '0')}:00`;
    const endTimeNew = `${endHoursHH.toString().padStart(2, '0')}:${endMintuesMM.toString().padStart(2, '0')}:00`;

    const formattedStartTime = this.convertToFullTimeFormat(startTimeNew);
    const formattedEndTime = this.convertToFullTimeFormat(endTimeNew);
    const duration = this.calculateDuration(formattedStartTime, formattedEndTime);

    const effectiveFrom = this.addOrEdit.effectiveFrom.value;
    const effectiveTo = this.addOrEdit.effectiveTo.value || '12/31/2999';

    const addEmittedData = {
      dock: this.addOrEdit.dock.value,
      shiftNumber: this.addOrEdit.shiftNumber.value,
      dayWeek: this.addOrEdit.dayWeek.value,
      startTime: startTimeNew,
      endTime: endTimeNew,
      duration,
      inNextDay: this.addOrEdit.inNextDay.value,
      inMasterCalendar: this.addOrEdit.inMasterCalendar.value,
      effectiveFrom,
      effectiveTo
    };
    // if (addEmittedData.inNextDay === 'N' && this.isStartTimeGreaterThanEndTime(startTimeNew, endTimeNew)) {
    //   this.errorMessage = 'For same-day shifts, start time must be earlier than end time.';
    //   return;
    // }

    // if (addEmittedData.inNextDay === 'Y' && !this.isStartTimeGreaterThanEndTime(startTimeNew, endTimeNew)) {
    //   this.errorMessage = 'For next-day shifts, start time must be later than end time (crossing midnight).';
    //   return;
    // }
    const isOvernight = this.isStartTimeGreaterThanEndTime(startTimeNew, endTimeNew);

    if (addEmittedData.inNextDay === 'N' && isOvernight) {
      this.errorMessage = 'Start time must be earlier than end time for same-day shifts.';
      return;
    }

    if (addEmittedData.inNextDay === 'Y' && !isOvernight) {
      this.errorMessage = 'Start time must be later than end time for next-day shifts.';
      return;
    }



    const request = {
      offset: 0,
      limit: 8000,
      business_entity: localStorage.getItem('namcvalue'),
      workid: localStorage.getItem('workdayId'),
      user_role: localStorage.getItem('UserRoles'),
      dock: [addEmittedData.dock]
    };

    this.ospService.getShiftDetails(request).subscribe({
      error: this.errorCallback,
      next: (res) => {
        const existingShifts = res?.body?.shiftResponce?.data || [];
        // const newFrom = formatDate(addEmittedData.effectiveFrom);
        // const newTo = formatDate(addEmittedData.effectiveTo);
        const currentDay = parseInt(addEmittedData.dayWeek);

        // const overlappingShifts = existingShifts.filter(shift => {
        //   const partFrom = formatDate(shift.from_date);
        //   const partTo = shift.to_date ? formatDate(shift.to_date) : '12/31/2999';
        //   return this.isEffectiveDateInRange(newFrom, newTo, partFrom, partTo);
        // });

        const newFrom = new Date(addEmittedData.effectiveFrom);
        const newTo = new Date(addEmittedData.effectiveTo);

        const overlappingShifts = existingShifts.filter(shift => {
          const partFrom = new Date(shift.from_date);
          const partTo = shift.to_date ? new Date(shift.to_date) : new Date('2999-12-31');

          return newFrom <= partTo && newTo >= partFrom;
        });

        const sameDayShift = overlappingShifts.find(s =>
          s.day_of_week == addEmittedData.dayWeek &&
          s.shift_no == addEmittedData.shiftNumber
        );

        if (sameDayShift) {
          const label = this.dayWeeks.find(day => day.value === +sameDayShift.day_of_week)?.label || sameDayShift.day_of_week;
          this.warningMessage = `A shift with the same day and shift number already exists: [${sameDayShift.shift_no}, ${label}]`;
          this.spinner.hide();
          return;
        }

        //  Overlap checking with midnight handling
        const timeToMinutes = (timeStr: string): number => {
          const [h, m] = timeStr.split(':').map(Number);
          return h * 60 + m;
        };
        const getShiftTimeRanges = (start: string, end: string, day: number) => {
          const startMin = timeToMinutes(start);
          let endMin = timeToMinutes(end);
          if (endMin < startMin) {
            // Overnight shift
            return [
              { day, start: startMin, end: 1440 },
              { day: (day % 7) + 1, start: 0, end: endMin } // Adjusted wrap for 1-based days
            ];
          }
          return [{ day, start: startMin, end: endMin }];
        };



        const newShiftRanges = getShiftTimeRanges(startTimeNew, endTimeNew, currentDay);

        for (const shift of overlappingShifts) {
          if (shift.shift_no == addEmittedData.shiftNumber) continue; // already checked above

          const existingShiftDay = parseInt(shift.day_of_week);
          const existingShiftRanges = getShiftTimeRanges(shift.start_time, shift.end_time, existingShiftDay);

          for (const newRange of newShiftRanges) {
            for (const existingRange of existingShiftRanges) {
              if (newRange.day === existingRange.day &&
                newRange.start < existingRange.end &&
                newRange.end > existingRange.start) {
                this.warningMessage = `New shift overlaps with existing shift: [Shift ${shift.shift_no}, Day ${shift.day_of_week}, ${shift.from_date}]`;
                this.spinner.hide();
                return;
              }
            }
          }
        }

        //  All checks passed
        this.rowData.push(addEmittedData);
        this.addShiftsEventEmitter.emit(addEmittedData);
        this.dialogeRef.close();
        this.spinner.hide();
      }
    });

    function formatDate(dateStr: string) {
      const date = new Date(dateStr);
      return `${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getDate().toString().padStart(2, '0')}/${date.getFullYear()}`;
    }
  }



  // Helper to format date as YYYY-MM-DD
  formatToYMD(dateStr: string): string {
    const date = new Date(dateStr);
    const yyyy = date.getFullYear();
    const mm = (date.getMonth() + 1).toString().padStart(2, '0');
    const dd = date.getDate().toString().padStart(2, '0');
    return `${yyyy}-${mm}-${dd}`;
  }


}